module.exports = __webpack_public_path__ + "static/media/fernandes-emir.8766403b.jpg";